(() => {
  const stages = document.querySelectorAll('[data-celestial-stage]');
  if (!stages.length) return;
  const visible = new Set();
  const sync = () => stages.forEach(stage => stage.classList.toggle('is-celestial-active', visible.has(stage) && !document.hidden));
  const observer = new IntersectionObserver(entries => {
    entries.forEach(({ target, isIntersecting }) => isIntersecting ? visible.add(target) : visible.delete(target));
    sync();
  });
  stages.forEach(stage => observer.observe(stage));
  document.addEventListener('visibilitychange', sync);
})();
